export const asianCountries = [
    {
      code: '+60',
      country: 'Malaysia',
      flag: 'my',
      pattern: /^[1-9]\d{7,9}$/,
      minLength: 8,
      maxLength: 10,
      example: '123456789',
    },
    {
      code: '+252',
      country: 'Somalia',
      flag: 'so',
      pattern: /^[67]\d{7,8}$/,
      minLength: 8,
      maxLength: 9,
      example: '61234567',
    },
    {
      code: '+65',
      country: 'Singapore',
      flag: 'sg',
      pattern: /^[689]\d{7}$/,
      minLength: 8,
      maxLength: 8,
      example: '81234567',
    },
    {
      code: '+66',
      country: 'Thailand',
      flag: 'th',
      pattern: /^[689]\d{8}$/,
      minLength: 9,
      maxLength: 9,
      example: '812345678',
    },
    {
      code: '+84',
      country: 'Vietnam',
      flag: 'vn',
      pattern: /^[1-9]\d{8,9}$/,
      minLength: 9,
      maxLength: 10,
      example: '912345678',
    },
    {
      code: '+62',
      country: 'Indonesia',
      flag: 'id',
      pattern: /^8\d{8,11}$/,
      minLength: 9,
      maxLength: 12,
      example: '812345678',
    },
    {
      code: '+63',
      country: 'Philippines',
      flag: 'ph',
      pattern: /^9\d{9}$/,
      minLength: 10,
      maxLength: 10,
      example: '9123456789',
    },
    {
      code: '+91',
      country: 'India',
      flag: 'in',
      pattern: /^[6-9]\d{9}$/,
      minLength: 10,
      maxLength: 10,
      example: '9123456789',
    },
    {
      code: '+86',
      country: 'China',
      flag: 'cn',
      pattern: /^1[3-9]\d{9}$/,
      minLength: 11,
      maxLength: 11,
      example: '13812345678',
    },
    {
      code: '+81',
      country: 'Japan',
      flag: 'jp',
      pattern: /^[789]0\d{8}$/,
      minLength: 10,
      maxLength: 10,
      example: '9012345678',
    },
    {
      code: '+82',
      country: 'South Korea',
      flag: 'kr',
      pattern: /^1[0-9]\d{7,8}$/,
      minLength: 9,
      maxLength: 10,
      example: '1012345678',
    },
    {
      code: '+852',
      country: 'Hong Kong',
      flag: 'hk',
      pattern: /^[5-9]\d{7}$/,
      minLength: 8,
      maxLength: 8,
      example: '51234567',
    },
    {
      code: '+853',
      country: 'Macau',
      flag: 'mo',
      pattern: /^6\d{7}$/,
      minLength: 8,
      maxLength: 8,
      example: '61234567',
    },
    {
      code: '+92',
      country: 'Pakistan',
      flag: 'pk',
      pattern: /^3\d{9}$/,
      minLength: 10,
      maxLength: 10,
      example: '3123456789',
    },
    {
      code: '+880',
      country: 'Bangladesh',
      flag: 'bd',
      pattern: /^1[3-9]\d{8}$/,
      minLength: 10,
      maxLength: 10,
      example: '1712345678',
    },
    {
      code: '+94',
      country: 'Sri Lanka',
      flag: 'lk',
      pattern: /^7\d{8}$/,
      minLength: 9,
      maxLength: 9,
      example: '712345678',
    },
    {
      code: '+95',
      country: 'Myanmar',
      flag: 'mm',
      pattern: /^9\d{8,9}$/,
      minLength: 9,
      maxLength: 10,
      example: '912345678',
    },
    {
      code: '+855',
      country: 'Cambodia',
      flag: 'kh',
      pattern: /^[1-9]\d{7,8}$/,
      minLength: 8,
      maxLength: 9,
      example: '12345678',
    },
    {
      code: '+856',
      country: 'Laos',
      flag: 'la',
      pattern: /^20\d{8}$/,
      minLength: 10,
      maxLength: 10,
      example: '2012345678',
    },
    {
      code: '+673',
      country: 'Brunei',
      flag: 'bn',
      pattern: /^[78]\d{6}$/,
      minLength: 7,
      maxLength: 7,
      example: '7123456',
    },
    {
      code: '+670',
      country: 'Timor-Leste',
      flag: 'tl',
      pattern: /^7\d{7}$/,
      minLength: 8,
      maxLength: 8,
      example: '71234567',
    },
    {
      code: '+7',
      country: 'Kazakhstan',
      flag: 'kz',
      pattern: /^7\d{9}$/,
      minLength: 10,
      maxLength: 10,
      example: '7012345678',
    },
    {
      code: '+998',
      country: 'Uzbekistan',
      flag: 'uz',
      pattern: /^[679]\d{8}$/,
      minLength: 9,
      maxLength: 9,
      example: '901234567',
    },
    {
      code: '+996',
      country: 'Kyrgyzstan',
      flag: 'kg',
      pattern: /^[57]\d{8}$/,
      minLength: 9,
      maxLength: 9,
      example: '501234567',
    },
    {
      code: '+992',
      country: 'Tajikistan',
      flag: 'tj',
      pattern: /^[39]\d{8}$/,
      minLength: 9,
      maxLength: 9,
      example: '901234567',
    },
    {
      code: '+993',
      country: 'Turkmenistan',
      flag: 'tm',
      pattern: /^6\d{7}$/,
      minLength: 8,
      maxLength: 8,
      example: '61234567',
    },
    {
      code: '+976',
      country: 'Mongolia',
      flag: 'mn',
      pattern: /^[89]\d{7}$/,
      minLength: 8,
      maxLength: 8,
      example: '81234567',
    },
    {
      code: '+975',
      country: 'Bhutan',
      flag: 'bt',
      pattern: /^[17]\d{7}$/,
      minLength: 8,
      maxLength: 8,
      example: '17123456',
    },
    {
      code: '+977',
      country: 'Nepal',
      flag: 'np',
      pattern: /^98\d{8}$/,
      minLength: 10,
      maxLength: 10,
      example: '9812345678',
    },
    {
      code: '+960',
      country: 'Maldives',
      flag: 'mv',
      pattern: /^[79]\d{6}$/,
      minLength: 7,
      maxLength: 7,
      example: '7123456',
    },
  ];